import { CSS } from '@stitches/react'
import { TOASTS, TOAST_ICONS } from './Toast.models'
import { ToasterRoot, ToasterIcon, CloseToaster, ToastMessage } from './Toaster.styled'
import React from 'react'
import { StyledText } from '@clickcease/cc-client-components-lib'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { ToasterType } from 'Types/ToasterTypes'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type ToasterProps = {
  children: React.ReactNode
  type: ToasterType
  onClose?: () => void
  hideCloseButton?: boolean
  duration?: number
  css?: CSS
}

export const Toast = ({
  children,
  onClose,
  type = TOASTS.info,
  hideCloseButton,
  duration,
}: ToasterProps) => {
  return (
    <ToasterRoot type={type} onOpenChange={onClose} duration={duration || 5000}>
      <ToasterIcon>{TOAST_ICONS[type]}</ToasterIcon>
      <ToastMessage>
        <StyledText variant={'baseLight'}>{children}</StyledText>
      </ToastMessage>
      {!hideCloseButton && (
        <CloseToaster>
          <FontAwesomeIcon icon={faXmark as IconProp} />
        </CloseToaster>
      )}
    </ToasterRoot>
  )
}
